import $ from 'jquery';

import { formValidator } from '../utils/form-validator';

const myProfile = () => {

  const init = () => {
    const form = $('[data-js=form].my-profile__details');

    if (form.length) {
      ModifiedInnovates2018Logic();
      GetLatestEventRequest();
    }

  }

  return ({
      init: init
  })
}

export default myProfile;


function ModifiedInnovates2018Logic() {

  var isFormValid = true;
  var grecaptchaWidget = "";
  var entitytype = {
    Nothing: 0,
    FederalGoverment: 1,
    LocalGoverment: 2,
    PrivateOther: 3
  }

  let $txtName = $('#txtName');
  let $Emirates = $('#ddlemirates');
  let $EntityType = $('#entityType');
  let $LocalGoverment = $('#ddlLocalGoverment');
  let $FederalGoverment = $('#ddlFederalGoverment');
  let $PrivateOther = $('#privateothertxt');
  let $Phone = $('#txtPhone');
  let $captcha = $('#grecaptcha');

  ShowSpecificField(true);

  const loader = createLoader(); /* For showing loading state */

  $EntityType.change(function () {

      ShowSpecificField(false);

      var selectedentityType = $('#selectedentitytype').val();
      var id = $Emirates.val();

      if (selectedentityType == entitytype.LocalGoverment && id != "" && id != undefined) {
          ShowSpecificField(false);
          $('#privateother').hide();
          GetLocalGovermnets(id);
      }
  });

  $Emirates.change(function () {

      var id = $(this).val();

      var selectedentityType = $('#selectedentitytype').val();

      if (selectedentityType == entitytype.LocalGoverment && id != "" && id != undefined) {
          ShowSpecificField(false);
          $('#privateother').hide();
          GetLocalGovermnets(id);
      }
  });

  $('.entityname').change(function () {

      ShowSpecificField(false);

  });

  fieldfocusOut();

  $('#btnUpdateProfile').click(function () {

      if (validForm()) {

          SaveData();
      }
      else {
          const el = $('.field-validation-error:first');
          if (el) {
              $('html,body').animate({ scrollTop: (el.offset().top - 100) }, 'slow', () => {
                  el.focus();
              });
          }
      }
  });




  function validForm() {

    isFormValid = true;

    var selectedentityType = $('#selectedentitytype').val();

    validatestringField($txtName, "namevalidation", "Full Name is not valid.", "الأسم الكامل الذي أدخلتة غير صحيح");
    validateDropDownField($Emirates, "emiratevalidation");
    validateDropDownField($EntityType, "entitytypevalidation");
    validateContactNo($Phone, "phonevalidation");
    validateCaptcha($captcha, "captchavalidation");

    if (selectedentityType == entitytype.LocalGoverment) {

        validateDropDownField($LocalGoverment, "localgovermentvalidation");

        var localgoverment = $('#ddlLocalGoverment option:selected').text().toLowerCase();

        if (localgoverment === "other" || localgoverment === "أخري") {

            validatestringField($PrivateOther, "privateothervalidation", "Private other is not valid.", "الشركات الخاصة الأخرى غير صحيحه");
        }
    }

    else if (selectedentityType == entitytype.FederalGoverment) {
        validateDropDownField($FederalGoverment, "federalgovermentvalidation");

        var federalgoverment = $('#ddlFederalGoverment option:selected').text().toLowerCase();

        if (federalgoverment === "other" || federalgoverment === "أخري") {

            validatestringField($PrivateOther, "privateothervalidation", "Private other is not valid.", "الشركات الخاصة الأخرى غير صحيحه");
        }
    }

    else if (selectedentityType == entitytype.PrivateOther) {
        validatestringField($PrivateOther, "privateothervalidation", "Private other is not valid.", "الشركات الخاصة الأخرى غير صحيحه");
    }



    return isFormValid;
  }

  function fieldfocusOut() {

    $txtName.on("focusout", function () {
        validatestringField($txtName, "namevalidation", "Full Name is not valid.", "الأسم الكامل الذي أدخلتة غير صحيح");
    });

    $Emirates.on("focusout", function () {
        validateDropDownField($Emirates, "emiratevalidation");
    });

    $EntityType.on("focusout", function () {
        validateDropDownField($EntityType, "entitytypevalidation");
    });

    $Phone.on("focusout", function () {
        validateContactNo($Phone, "phonevalidation");
    });

    $captcha.on("focusout", function () {
        validateCaptcha($captcha, "captchavalidation");
    });
  }

  function ShowSpecificField(isFormLoad) {
    setother(false);
    hideFields(isFormLoad);
    SetEntityType(entitytype.Nothing);
    formValidator.clearOneErrorMessage("privateothervalidation");

    var value = $('#entityType option:selected').text().toLowerCase();
    var localgoverment = $('#ddlLocalGoverment option:selected').text().toLowerCase();
    var federalgoverment = $('#ddlFederalGoverment option:selected').text().toLowerCase();

    if (value === "local goverment" || value === "جهات محلية") {

        showFields($('#entitynamediv, #localGoverment'))
        SetEntityType(entitytype.LocalGoverment);

        if (localgoverment === "other" || localgoverment === "أخري") {
            setother(true);
            showFields($('#privateother'));
        }
    }

    else if (value === "federal goverment" || value === "جهات إتحادية") {
        $('#entitynamediv,#federalGoverment').show();
        SetEntityType(entitytype.FederalGoverment);

        if (federalgoverment === "other" || federalgoverment === "أخري") {
            setother(true);
            showFields($('#privateother'));
        }

    }

    else if (value === "private/other" || value === "أخري /خاص") {
        $('#entitynamediv,#privateother').show();
        SetEntityType(entitytype.PrivateOther);
    }

    onoffEvent();

  }

  function setother(value) {
    $('#othervalue').val(value);
  }

  function hideFields(isFormLoad) {

    var value = $EntityType.val();

    if (value === "" || value === undefined) {

        $('#entitynamediv').hide();
    }
    else {

        $('#localGoverment').hide();
        $('#federalGoverment').hide();
        $('#privateother').hide();
    }
    $('#localgovermentvalidation').remove();
    $('#privateothervalidation').remove();
    $('#federalgovermentvalidation').remove();

    if (!isFormLoad) {
        $PrivateOther.val("");
    }
  }

  function SetEntityType(type) {

    $('#selectedentitytype').val(type);
  }

  function showFields(elements) {
    elements.show();
  }

  function validatestringField(element, id, enText, arText) {

    if (vlidateRequiredField(element, id)) {

        var value = element.val();

        if (!formValidator.validateStringField(value)) {

            var message = formValidator.getLanguage() === "en" ? enText : arText;

            formValidator.setErrorMessage(element, message, id);

            isFormValid = false;
        }
    }

  }

  function validateDropDownField(element, id) {

    formValidator.clearOneErrorMessage(id);

    var value = element.val();

    if (value === "" || value === undefined) {

        var message = formValidator.getLanguage() === "en" ? "Please select an option" : "الرجاء أختر";

        formValidator.setErrorMessageForCategory(element, message, id);

        isFormValid = false;
    }
  }

  function vlidateRequiredField(element, id) {

    formValidator.clearOneErrorMessage(id);

    var value = element.val();

    var message = formValidator.getLanguage() === "en" ? "You can’t leave this blank" : "لا يمكنك ترك هذا الحقل فارغا";

    if (formValidator.isEmpty(value)) {

        formValidator.setErrorMessage(element, message, id);
        isFormValid = false;
        return false;
    }

    return true;
  }

  function validateContactNo(element, id) {
    if (vlidateRequiredField(element, id)) {

        var value = element.val();

        if (!formValidator.validateConatctNo(value)) {

            var message = formValidator.getLanguage() === "en" ? "Contact number is not valid" : "رقم التواصل الذي أدخلته غير صحيح";

            formValidator.setErrorMessage(element, message, id);

            isFormValid = false;
        }
    }
  }

  function validateCaptcha(element, id) {

    formValidator.clearOneErrorMessage(id);

    var response = grecaptcha.getResponse();
    if (response.length == 0) {

        var message = formValidator.getLanguage() === "en" ? "You can’t leave this blank" : "لا يمكنك ترك هذا الحقل فارغا";
        formValidator.setErrorMessage(element, message, id);
        isFormValid = false;
    }
  }

  function onoffEvent() {

    var selectedentityType = $('#selectedentitytype').val();

    $LocalGoverment.off("focusout");
    $FederalGoverment.off("focusout");
    $PrivateOther.off("focusout");

    if (selectedentityType == entitytype.LocalGoverment) {

        $LocalGoverment.on("focusout", function () {
            validateDropDownField($LocalGoverment, "localgovermentvalidation");
        });

        var localgoverment = $('#ddlLocalGoverment option:selected').text().toLowerCase();

        if (localgoverment === "other" || localgoverment === "أخري") {

            $PrivateOther.on("focusout", function () {
                validatestringField($PrivateOther, "privateothervalidation", "Private other is not valid.", "الشركات الخاصة الأخرى غير صحيحه");
            });
        }
    }

    else if (selectedentityType == entitytype.FederalGoverment) {

        $FederalGoverment.on("focusout", function () {
            validateDropDownField($FederalGoverment, "federalgovermentvalidation");
        });

        var federalgoverment = $('#ddlFederalGoverment option:selected').text().toLowerCase();

        if (federalgoverment === "other" || federalgoverment === "أخري") {

            $PrivateOther.on("focusout", function () {
                validatestringField($PrivateOther, "privateothervalidation", "Private other is not valid.", "الشركات الخاصة الأخرى غير صحيحه");
            });
        }

    }

    else if (selectedentityType == entitytype.PrivateOther) {

        $PrivateOther.on("focusout", function () {
            validatestringField($PrivateOther, "privateothervalidation", "Private other is not valid.", "الشركات الخاصة الأخرى غير صحيحه");
        });
    }
  }

  function GetLocalGovermnets(emirateUId) {

    loader.enable();

    $.ajax({
        type: 'GET',
        url: "/api/User/GetLocalGoverment",
        dataType: "html",
        cache: false,
        data: { emirateUId: emirateUId, culture: formValidator.getLanguage() },
        error: function (data) {
            console.log(data);
            //alert("error occured")
        },

        success: function (data) {

            $LocalGoverment.empty();

            var jsonObject = JSON.parse(data);

            var message = formValidator.getLanguage() === "en" ? "Please select" : "الرجاء أختر";
            $LocalGoverment.append('<option value = "">' + message + '</option>');

            $.each(jsonObject, function (i, local) {


                $LocalGoverment.append('<option value = ' + local.Id + '>' + local.Value + '</option>');

            });

        },

        complete: function () {
          loader.disable();
        }
    });
  }

  function disableFields() {

    $('#ddlemirates,#entityType,#ddlLocalGoverment,#ddlFederalGoverment,#privateothertxt').attr('disabled', 'disabled');

  }

  function SaveData() {

    var language = document.documentElement.lang;
    loader.enable();
    var url = location.pathname + "/UpdateProfile";

    $.ajax({
        type: 'Post',
        url: url,
        data: {

            'Name': $txtName.val(), 'Phone': $Phone.val(), 'EmirateUId': $Emirates.val(),
            'LocalGovermentUId': $LocalGoverment.val(), 'FederalGovermentUId': $FederalGoverment.val(), 'PrivateOther': $PrivateOther.val(),
            'Other': $('#othervalue').val(), 'SelectedEntitytype': $('#selectedentitytype').val(), 'EntityTypeUId': $EntityType.val(),
            'captcha': grecaptcha.getResponse()
        },
        cache: false,
        error: function (data) {
            console.log(data);
            //var language = document.documentElement.lang;
            var errorMessage = language == "en" ? "Error Occured!" : "حدث خطأ!";
            $('div#showMessage').html("<div class='alert alert-danger' role='alert'>" + errorMessage + "</div>");
        },

        success: function (data) {

            if (data.ResponseCode == 0 || data.ResponseCode == 1 || data.ResponseCode == 3) {

                var message = language == "en" ? "User profile not updated." : "لم يتم تحديث بياناتك الشخصية";
                $('div#showMessage').html("<div class='alert alert-danger' role='alert'>" + message + "</div>");
            }

            else if (data.ResponseCode == 2) {
                var message = language == "en" ? "User profle updated successfully." : "تم تحديث بياناتك بنجاح";
                $('div#showMessage').html("<div class='alert alert-success' role='alert'>" + message + "</div>");
                disableFields();

                var redirectUrl = language == "en" ? "/en/uaedashboard" : "/ar/uaedashboardar";

                window.location.href = redirectUrl;
            }

        },

        complete: function () {
            loader.disable();
            $('#showMessage').fadeOut(10000, "linear", function () {
                $("div#showMessage").html("");
                $("div#showMessage").removeAttr("style");
            });
        }
    });

  }
};

function GetLatestEventRequest() {
  const loaderContainer = $('[data-my-profile-event-container]');
  const name = $('[data-my-profile-name]');
  const status = $('[data-my-profile-status]');
  const date = $('[data-my-profile-date]');

  const elementsAreFound = loaderContainer.length && name.length && status.length && date.length;

  if (!elementsAreFound) {
    console.error('HTML elements were not found for latest event');
    return;
  }

  loaderContainer.addClass('circle-loader__parent--loading');

  const culture = document.documentElement.lang;
  $.ajax({
    type: "Get",
    url: "/UaeMyRequest/GetData",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: { culture },
    success: function (data) {
      const earliestEvent = getEarliestEvent(data);

      if (earliestEvent) {
        name.text((culture == 'en' ? earliestEvent.ExcelSheetNameEn : earliestEvent.ExcelSheetNameAr) || 'Unavailable');
        status.text(earliestEvent.Status || 'Unavailable');
        date.text(earliestEvent.StartDate || 'Unavailable');
      }

      loaderContainer.removeClass('circle-loader__parent--loading');
    },
    error: function (xhr, ajaxOptions, thrownError) {
      loaderContainer.removeClass('circle-loader__parent--loading');
      console.log("\n\t*** ajax call failure! : (readyState: " +
                      xhr.readyState + " - status: " + xhr.status + " " + xhr.statusText +
                      ") Error Message: " + thrownError.message + " ***");

    }
  });

}

function getEarliestEvent(events) {
  if (!events.length) {
    return;
  }

  return events.reduce((earliestEvent, current) => {
    const currentStartDate = new Date(current.StartDate);
    const minStartDate = new Date(earliestEvent.StartDate);
    if (currentStartDate < minStartDate) {
      return current;
    }
    return earliestEvent;
  }, events[0]);
}

function createLoader() {
  const form = $('[data-js=form]');

  const enable = () => {
    $(form).addClass('circle-loader__parent--loading');
  }

  const disable = () => {
    setTimeout(() => {
      $(form).removeClass('circle-loader__parent--loading');
    }, 2000)
  }

  return {
    enable,
    disable
  }
}
